/* Ceplino — ürün kartlarındaki indirim etiketini gerçek fiyatlardan yüzde olarak gösterir. */
(function () {
  function parsePrice(text) {
    if (!text) return NaN;
    var s = text.replace(/[^\d.,]/g, '');
    var dec = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    if (dec > -1 && s.length - dec - 1 === 2) {
      return parseFloat(s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1));
    }
    return parseFloat(s.replace(/[.,]/g, ''));
  }

  function updateBadges(root) {
    var label = document.documentElement.getAttribute('data-ceplino-sale-label') || 'İndirim';
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      var price = card.querySelector('.price--on-sale');
      var badge = card.querySelector('.card__badge .badge');
      if (!price || !badge || badge.hasAttribute('data-ceplino-pct')) return;
      var regular = price.querySelector('.price__sale .price-item--regular');
      var sale = price.querySelector('.price__sale .price-item--sale');
      var r = parsePrice(regular && regular.textContent);
      var s = parsePrice(sale && sale.textContent);
      if (r > s && s > 0) {
        var pct = Math.round(((r - s) / r) * 100);
        if (pct > 0) {
          badge.textContent = '%' + pct + ' ' + label;
          badge.setAttribute('data-ceplino-pct', pct);
        }
      }
    });
  }

  function init() {
    if (!document.documentElement.hasAttribute('data-ceplino-sale-label')) return;
    updateBadges();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(updateBadges, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();